<template>
  <v-form ref="SALARIE_INFORMATIONS" @submit.prevent="sectionSave" lazy-validation class="section">
    <div>
      <section-header v-if="!hideTitle"
                      :ressource="ressource"
                      :isExtended="extended"
                      :dialog="dialog"
                      :picto="picto()"
                      :fiche=fiche
                      :isAbstract=isAbstract
                      @extended=setExtended
                      @closeDialog=closeDialog
                      ref="SALARIE_INFORMATIONS">
      </section-header>
      <div v-if="extended" id="field-container" :class="dialog ? 'p-0 p-md-3' : 'py-2'">
        <salarie-pseudo v-if="isDisplayed('PSEUDO')"
                        ref="PSEUDO"
                        :theme="theme"
                        :showMissing="showMissing"
                        v-model:value=pseudo
                        :min="3"
                        :max="25"
                        @status=statusPseudo
                        :over-ride-placeholder=placeholderPseudo
                        :required="isRequired('PSEUDO')"
                        :contextId=salarie.id
                        :readOnly="readOnly('PSEUDO')"
                        :objType=objType
                        :fiche=fiche
                        :sectionName="sectionName">
        </salarie-pseudo>
        <salarie-statut-handicap v-if="isDisplayed('STATUT_HANDICAP')"
                                 ref="STATUT_HANDICAP"
                                 :theme="theme"
                                 :showMissing="showMissing"
                                 v-model:value=statutHandicap
                                 @status=statusStatutHandicap
                                 :required="isRequired('STATUT_HANDICAP')"
                                 :contextId=salarie.id
                                 :readOnly="readOnly('STATUT_HANDICAP')"
                                 :objType=objType
                                 :fiche=fiche
                                 :sectionName="sectionName">
        </salarie-statut-handicap>
        <salarie-date-handicap v-if="isDisplayed('DATE_HANDICAP')"
                               ref="DATE_HANDICAP"
                               :theme="theme"
                               :showMissing="showMissing"
                               v-model:value=dateHandicap
                               @status=statusDateHandicap
                               :periods='periodDateHandicap'
                               :required="isRequired('DATE_HANDICAP')"
                               :contextId=salarie.id
                               :readOnly="readOnly('DATE_HANDICAP')"
                               :objType=objType
                               :fiche=fiche
                               :sectionName="sectionName">
        </salarie-date-handicap>
        <salarie-numero-conge-spec v-if="isDisplayed('NUMERO_CONGE_SPEC')"
                                   ref="NUMERO_CONGE_SPEC"
                                   :theme="theme"
                                   :showMissing="showMissing"
                                   v-model:value=numeroCongeSpec
                                   @status=statusNumeroCongeSpec
                                   :over-ride-placeholder=placeholderNumeroCongeSpec
                                   :required="isRequired('NUMERO_CONGE_SPEC')"
                                   :contextId=salarie.id
                                   :readOnly="readOnly('NUMERO_CONGE_SPEC')"
                                   :objType=objType
                                   :fiche=fiche
                                   :sectionName="sectionName">
        </salarie-numero-conge-spec>
        <salarie-abattement v-if="isDisplayed('ABATTEMENT')"
                            ref="ABATTEMENT"
                            :theme="theme"
                            :showMissing="showMissing"
                            v-model:value=abattement
                            @status=statusAbattement
                            :required="isRequired('ABATTEMENT')"
                            :contextId=salarie.id
                            :readOnly="readOnly('ABATTEMENT')"
                            :objType=objType
                            :fiche=fiche
                            :sectionName="sectionName">
        </salarie-abattement>
      </div>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <loader-button v-if="saveButton"
                     class="ms-2"
                     type="submit"
                     :loading="saveLoading"
                     :label="saveLabel"
                     :disabled="!updatedAndValid">
      </loader-button>
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button class="ms-2"
                       :outlined="button.outlined"
                       @callback="button.callback()"
                       :type="button.type"
                       :label="button.label"
                       :loading="button.loading"
                       :disabled="button.disabled">
        </loader-button>
      </div>
    </div>
    <div class="d-flex flex-row-reverse" v-if="saveFailed && saveButton && extended">
      <p class="text-12 text-bold error-text">{{errorTxt}}</p>
    </div>
  </v-form>
</template>

<script lang="ts">
  import { defineComponent } from "vue";
  import CrudSalarie from '@/generated/cruds/CrudSalarie';
  // eslint-disable-next-line
  import { GenControl, GenSection, RessourceGenControl, RessourceGenSection } from '@/generated/ressources/generatedRessources';
  import { FwkButtons, RessourceFwkButton, RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { Sections } from '@/generated/classes/AppSchema';
  import Button, { ButtonCallback } from '@/framework/base/classes/Button';
  import { ObjTypes } from '@/generated/classes/ObjTypes';

  export default defineComponent({
    extends:  CrudSalarie,
    components: {},
    props: {
      hideTitle: {
        type: Boolean,
      },
      isAbstract: {
        type: Boolean,
      },
    },

    data() {
      return {
        sectionName: Sections.SALARIE_INFORMATIONS,
        displayMap: new Map<string, Boolean>,
        readOnlyMap: new Map<string, Boolean>,
        requiredMap: new Map<string, Boolean>,
        placeholderPseudo: null,
        placeholderNumeroCongeSpec: null,
      }
    },

    computed: {
      saveLabel () { 
        return RessourceFwkButton(FwkButtons.ENREGISTRER).label;
      },

      errorTxt () { 
        return RessourceFwkSection(FwkSections.ERROR_TEXT).label;
      },


      ressource () { return RessourceGenSection(GenSection.SALARIE_INFORMATIONS); },

      fields (): string[] {
        return ['PSEUDO', 'STATUT_HANDICAP', 'DATE_HANDICAP', 'NUMERO_CONGE_SPEC', 'ABATTEMENT'];
      },

      extraButtons (): Button[] {
        return [];
      },

    },
    methods: {
      getRequiredAttributs(): string[] {
        const res: string[] = [];
        if (this.requiredAttributs) {
          this.requiredAttributs.forEach((attrib) => {
            const value = attrib.split(".");
            if (value[0] == this.sectionName) {
              res.push(value[1])
            }
          })
        }
        return res;
      },

      requiredMissing(requiredAttributs: string[], value: string): boolean {
        return requiredAttributs.length > 0 && requiredAttributs.includes(value);;
      },

      readOnly (value: string): boolean {
        let res = false;
        if (!this.editSalarie.canUpdate) {
          return true;
        }
        if (this.readOnlyMap.size == 0) {
          this.readOnlyMap.set("PSEUDO", false);
          this.readOnlyMap.set("STATUT_HANDICAP", false);
          this.readOnlyMap.set("DATE_HANDICAP", false);
          this.readOnlyMap.set("NUMERO_CONGE_SPEC", false);
          this.readOnlyMap.set("ABATTEMENT", false);
        }
        const readOnly = this.readOnlyMap.get(value);
        if (readOnly != undefined) {
          res = readOnly;
        }
        return res;
      },

      isDisplayed (value: string): boolean {
        let res = true;
        if (this.displayMap.size == 0) {
        const requiredAttributs = this.getRequiredAttributs();
          this.displayMap.set("PSEUDO", this.requiredMissing(requiredAttributs, "PSEUDO") || !!this.fiche);
          this.displayMap.set("STATUT_HANDICAP", this.requiredMissing(requiredAttributs, "STATUT_HANDICAP") || !!this.fiche);
          this.displayMap.set("DATE_HANDICAP", this.requiredMissing(requiredAttributs, "DATE_HANDICAP") || !!this.fiche);
          this.displayMap.set("NUMERO_CONGE_SPEC", this.requiredMissing(requiredAttributs, "NUMERO_CONGE_SPEC") || !!this.fiche);
          this.displayMap.set("ABATTEMENT", this.requiredMissing(requiredAttributs, "ABATTEMENT") || !!this.fiche);
        }
        const display = this.displayMap.get(value);
        if (display != undefined) {
          res = display;
        }
        return res;
      },

      isRequired (value: string): boolean {
        let res = true;
        const requiredAttributs = this.getRequiredAttributs();
        if (this.requiredMap.size == 0) {
          this.requiredMap.set("PSEUDO", this.requiredMissing(requiredAttributs, "PSEUDO") || !this.fiche);
          this.requiredMap.set("STATUT_HANDICAP", this.requiredMissing(requiredAttributs, "STATUT_HANDICAP") || !this.fiche);
          this.requiredMap.set("DATE_HANDICAP", this.requiredMissing(requiredAttributs, "DATE_HANDICAP") || !this.fiche);
          this.requiredMap.set("NUMERO_CONGE_SPEC", this.requiredMissing(requiredAttributs, "NUMERO_CONGE_SPEC") || !this.fiche);
          this.requiredMap.set("ABATTEMENT", this.requiredMissing(requiredAttributs, "ABATTEMENT") || !this.fiche);
        }
        const required = this.requiredMap.get(value);
        if (required != undefined) {
          res = required;
        }
        return res;
      },

      picto (): string {
        return 'SectionPictoInformations' 
      },

      sectionSave (): void {
        return this.save();
      }
    }
  })
</script>
